export class NetworkError {

  status: string;
  errorCode: number;
  body: object;

  constructor(status: string, errorCode: number, body: object) {
    this.status = status;
    this.errorCode = errorCode;
    this.body = body;
  }
}
